import { amazon } from "@/i18n/de-de/components/salesChannelManagementApp/amazon";
import { tiktok } from "@/i18n/de-de/components/salesChannelManagementApp/tiktok";
import { molliePos } from "@/i18n/de-de/components/salesChannelManagementApp/mollie-pos";
import { product } from "@/i18n/de-de/components/salesChannelManagementApp/product";
import { prices } from "@/i18n/de-de/components/salesChannelManagementApp/prices";
import { tracking } from "@/i18n/de-de/components/salesChannelManagementApp/tracking";
import { shopify } from "@/i18n/de-de/components/salesChannelManagementApp/shopify";
import { orders } from "@/i18n/de-de/components/salesChannelManagementApp/orders";
import { stock } from "@/i18n/de-de/components/salesChannelManagementApp/stock";
import { settings } from "@/i18n/de-de/components/salesChannelManagementApp/settings";
import { woocommerce } from "@/i18n/de-de/components/salesChannelManagementApp/woocommerce";
import { category } from "@/i18n/de-de/components/salesChannelManagementApp/category";
import { migration } from "@/i18n/de-de/components/salesChannelManagementApp/migration";
import { test } from "@/i18n/de-de/components/salesChannelManagementApp/test";
import { bigcommerce } from "@/i18n/de-de/components/salesChannelManagementApp/bigcommerce";
import { reporting } from "@/i18n/de-de/components/salesChannelManagementApp/reporting";
import { productSelection } from "@/i18n/de-de/components/salesChannelManagementApp/productSelection";
import { shopware6 } from "@/i18n/de-de/components/salesChannelManagementApp/shopware6";
import { otto } from "@/i18n/de-de/components/salesChannelManagementApp/otto";
import { journal } from "@/i18n/de-de/components/salesChannelManagementApp/journal";
import { offer } from "@/i18n/de-de/components/salesChannelManagementApp/offer";
import { links } from "@/i18n/de-de/components/salesChannelManagementApp/links";
import { helpArea } from "@/i18n/de-de/components/salesChannelManagementApp/helpArea";
import { saveDialog } from "@/i18n/de-de/components/salesChannelManagementApp/saveDialog";
import { easyCompliance } from "@/i18n/de-de/components/salesChannelManagementApp/easyCompliance";
import { auth } from "@/i18n/de-de/components/salesChannelManagementApp/auth";
import { integrationStatus } from "@/i18n/de-de/components/salesChannelManagementApp/integrationStatus";
import { ebay } from "@/i18n/de-de/components/salesChannelManagementApp/ebay";
import { kaufland } from "@/i18n/de-de/components/salesChannelManagementApp/kaufland";
import { woltdelivery } from "@/i18n/de-de/components/salesChannelManagementApp/woltdelivery";
import { exact } from "@/i18n/de-de/components/salesChannelManagementApp/exact";
import { gambio } from "@/i18n/de-de/components/salesChannelManagementApp/gambio";
import { bexio } from "@/i18n/de-de/components/salesChannelManagementApp/bexio";
import { etsy } from "@/i18n/de-de/components/salesChannelManagementApp/etsy";
import { abaninja } from "@/i18n/de-de/components/salesChannelManagementApp/abaninja";

export const salesChannelManagementApp = {
  active: "Aktiv",
  activeHelp: "Ist der Workflow aktiv?",
  account: "Erlöskonto",
  addIntegration: "Neue Integration",
  advancedPricing: "Erweiterte Preise",
  all: "Alle",
  auth: auth,
  helpArea: helpArea,
  amazon: amazon,
  exact: exact,
  bexio: bexio,
  etsy: etsy,
  abaninja: abaninja,
  gambio: gambio,
  ebay: ebay,
  tiktok: tiktok,
  woltdelivery: woltdelivery,
  "mollie-pos": molliePos,
  easyCompliance: easyCompliance,
  apiKey: "API Key",
  apiKeyHelp: "Authentifizierungsdaten 1",
  appSaved: "Die Integration {integrationName} wurde gespeichert.",
  articleCount: "Anzahl Artikel",
  assignment: "Kategoriezuordnung",
  assignmentSelectManual: "Manuelle Zuordnungstabelle",
  assignmentStrategyManual: "Manuelle Zuordnungstabelle",
  assignmentTableShop: "{appName}",
  assignmentTableXentral: "Xentral",
  authFailed:
    "Die Anmeldung bei Connect ist fehlgeschlagen. Bitte versuche es erneut.",
  authRetry: "Erneut authentifizieren",
  authorize: "Autorisieren",
  authModeToggle: "Automatisch einen Token generieren",
  authHelpText:
    "Beim Klick auf den Button, wird bei der Erstellung der Integration automatisch ein Zugangstoken für {appName} über den Xentral-ERP Connector generiert.",
  authModeToggleInfo:
    "Wenn aktiviert, wird bei der Erstellung der Integration automatisch ein Zugangstoken für {appName} über den Xentral-ERP Connector generiert. Wenn deaktiviert, können die Zugangsdaten manuell eingegeben werden.",
  autoAcceptOrders: "Aufträge automatisch akzeptieren",
  autoAcceptOrdersHelp:
    "Hier kannst du festlegen, ob neue Aufträge im Marktplatz automatisch akzeptiert werden.",
  back: "Zurück",
  backToOverview: "Übersicht",
  baseData: "Stammdaten (exkl. Preise und Bestände)",
  baseSettings: "Basiseinstellungen",
  bigcommerce: bigcommerce,
  calculateStock: "Lagerbestand berechnen",
  cancellation: "Storno",
  cancellationStates: "Shopseitige Stornierungen",
  carrier: "Versanddienstleister",
  carrierAssignment: "Versanddienstleister-Zuordnung",
  category: category,
  categoryAssignment: "Kategoriezuordnung",
  categoryLabel: "Kategorie",
  changeActiveStatusTextActive:
    "Achtung! Wenn du deine Integration aktiv schaltest, werden Daten automatisch mit deinem Verkaufskanal synchronisiert. Diese Änderung greift erst beim nächsten Speichern.",
  changeActiveStatusTextInactive:
    "Achtung! Wenn du deine Integration inaktiv schaltest, werden Daten nicht mehr automatisch mit deinem Verkaufskanal synchronisiert. Diese Änderung greift erst beim nächsten Speichern.",
  changeActiveStatusTitle: "Modus der Integration ändern?",
  clientId: "Client ID",
  clientSecret: "Client Secret",
  collection: "Collection",
  country: "Land",
  countryAssignment: "Länderzuordnung",
  credentials: "Zugangsdaten",
  currency: "Währung",
  currencyAssignment: "Währungszuordnung",
  customField: "Freifeld",
  customFieldAssignment: "Freifeldzuordnung",
  customFields: "Freifelder",
  customer: "Kundenzuordnung",
  customerGroup: "Kundengruppe",
  customers: "Kundenzuordnung",
  content: "Waren-/Leistungsprüfung",
  dataTypes: "Datentypen",
  dataTypesHelp: "Welche Datentypen sollen übertragen werden?",
  date: "Datum",
  deltaTransmission: "Deltaübetragung",
  deltaTransmissionHelp: "Welche Artikel sollen übertragen werden?",
  deliveryTime: "Lieferzeit",
  deliveryNote: "Lieferschein",
  descriptions: {
    baseData: "Fügen Sie hier die Basisdaten für Ihre neue Integration ein.",
    credentials: "Verbinden der Systeme.",
    features: "Aktiviere deine benötigten Features.",
    tbOneChannelSelection: "Wähle deine TB.One Kanäle aus",
    sftpData: "Hinterlege deine SFTP Daten"
  },
  depositProduct: "Pfand",
  discountProduct: "Rabatte",
  discounts: "Gutschriften & Rabatte",
  exportActive:
    "Deine Integration wird vorbereitet. Bitte hab noch etwas Geduld. Sobald die Integration fertig angelegt ist kannst du diese hier konfigurieren.",
  exportRules: "Exportregeln",
  examination: "Untersuchung",
  featureCategory: "Kategorien abgleichen (Xentral > Verkaufskanal)",
  featureOffer:
    "Angebote (inkl. Preise und Bestände) abgleichen (Xentral > Verkaufskanal)",
  featureOrders: "Aufträge abgleichen (Verkaufskanal > Xentral)",
  featurePrices: "Preise abgleichen (Xentral > Verkaufskanal)",
  featureProduct:
    "Artikel (exkl. Preise und Bestände) abgleichen (Xentral > Verkaufskanal)",
  featureRequired: "Bitte mindestens ein Feature auswählen",
  featureStock: "Bestände abgleichen (Xentral > Verkaufskanal)",
  featureTracking:
    "Auftragsstatus und Tracking abgleichen (Xentral > Verkaufskanal)",
  featureReceipt: "Belege (Xentral > Verkaufskanal)",
  featurePaymentTransactions: "Rückzahlungen (Xentral > Verkaufskanal)",
  features: "Features",
  feed: "Sendungsdaten-Feed",
  freeFieldAssignment: "Kontierung",
  group: "Warengruppe",
  general: "Allgemein",
  giftWrapProduct: "Geschenkverpackung",
  help: "<div>Schwierigkeiten?</div><div>Besuche unser <a href='https://help.xentral.com/' target='_blank'>Helpcenter</a></div>",
  info: "Hinweis",
  integrationStatus: integrationStatus,
  initArticleImport: "Initialer Artikelimport",
  initialFile: {
    generateInitialFile: "Initiale Datei erzeugen",
    dialogTitle: "Initiale Datei",
    productDialogInfo:
      "Für das initiale Mapping deiner Artikeldaten in Mirakl wird eine Importdatei benötigt. Achte darauf dass diese ausreichend Artikel enthält, so dass alle vergebenen Artikelkategorien mindestens einmal enthalten sind.",
    offerDialogInfo:
      "Hier kannst du eine CSV-Datei mit Angeboten für den initialen Import erstellen.",
    building: "Die initiale Importdatei wird erzeugt",
    buildingInfo:
      "Sobald die initiale Importdatei erzeugt wurde, kannst du diese über den oben angezeigten Link herunterladen.",
    limit: "Limit",
    all: "Alle",
    failed:
      "Die letzte Statusmeldung ist älter als eine Stunde. Möglicherweise ist das erstellen der initialen Importdatei abgebrochen und kann neu gestartet werden.",
    started:
      "Das Erstellen der initialen Importdatei wurde gestartet. Es kann ein paar Minuten dauern, bis der Status verfügbar ist."
  },
  links: links,
  initialFileCreatedAt: "Zuletzt erzeugt am",
  initialFileName: "Link zur Datei",
  integration: {
    dev: "Die Integration befindet sich im Entwicklungsmodus.",
    live: "Die Integration befindet sich im Produktivmodus."
  },
  integrationActiveHelp: "Ist diese Integration aktiv?",
  journal: journal,
  key: "Consumer Key",
  keyword: "Keyword",
  language: "Sprache",
  languageAssignment: "Sprachenzuordnung",
  layout: "Ansicht der Artikel",
  lineItems: "Auftragspositionen",
  liveDevMode: "Integrationsmodus",
  livemode: "Produktiv",
  livemodeActive: "Produktivmodus aktivieren",
  livemodeError:
    "Aktivierung fehlgeschlagen. Fülle alle markierten Pflichtfelder aus.",
  location: "Lagerorte im Verkaufskanal",
  loadIntegration:
    "Ihre Integration wird geladen. Dieser Vorgang kann etwas dauern.",
  mail: "Mailversand",
  manual: "Manuell",
  markReady: "Als bereit markieren",
  marketPlace: "Marktplatz",
  marketPlacePlural: "Marktplätze",
  marketplaceLanguageAssignment: "Sprachenzuordnung",
  media: "Medien",
  metaTexts: "Meta Texte",
  migration: migration,
  mode: "Modus",
  modeHelp: "Wird die Integration live verwendet?",
  name: "Name der Integration",
  nameHelp:
    "Wie soll die neue Integration benannt werden? Bitte beachte, dass der Integrationsname eindeutig sein muss.",
  newTokenSuccess: "Erolgreich neuen Token erstellt",
  next: "Weiter",
  no: "Nein",
  noConfigAvailable: "Keine Konfigurationen verfügbar",
  notification: "Benachrichtigungen",
  of: "von",
  offer: offer,
  onChange: "Bei Änderung",
  onlineStatus: "Online-Status",
  openingTimes: "Öffnungszeiten",
  orderStates: "Bestellstatus im Shop",
  orders: orders,
  otto: otto,
  password: "Passwort / API-Schlüssel",
  passwordHelp: "Authentifizierungsdaten 2",
  payment: "Zahlungsarten",
  paymentAndShippingState: "Zahlungs- und Versandstatus",
  paymentMethod: "Zahlungsart",
  paymentMethods: "Zahlungsarten",
  paymentState: "Zahlungsstatus",
  pos: "POS Kunden",
  position: "Positionen",
  priceRule: "Preisregeln",
  priceSelection: "Preisauswahl",
  specialPriceSelection: "Spezial-Preisauswahl",
  priceTitle: "Preise",
  prices: prices,
  product: product,
  productAssignment: "Artikelzuordnung",
  productBaseData: "Stammdaten",
  productSelection: productSelection,
  productSelectionTable: {
    id: "ID",
    name: "Name",
    productNumber: "Artikel Nr.",
    ean: "EAN Nr. / Barcode",
    isDisabled: "Sperre aktiv",
    projectId: "Projekt ID",
    merchandiseGroupId: "Artikelkategorie ID"
  },
  project: "Projekt",
  projectHelp: "Welchem Projekt in Xentral ist die Integration zugeordnet?",
  properties: "Eigenschaften",
  publication: "Sales Channel",
  remark: "Kommentare",
  reporting: reporting,
  returnStates: "Retourenstatus",
  returns: "Retouren",
  salesChannelAssignment: "Projektzuordnung",
  salesChannels: "Sales Channels",
  save: "Speichern",
  saveIntegration:
    "Ihre Integration wird erstellt. Dieser Vorgang kann einige Zeit dauern.",
  secret: "Consumer Secret",
  settings: settings,
  salesOrder: "Aufträge",
  shipFromAddress: "Lageradresse",
  shipping: "Versandarten & Lieferbedingungen",
  shippingCosts: "Versandkosten",
  shippingCostsDiscountsTaxes: "Versandkosten, Rabatte und Steuern",
  shippingMethod: "Versandart",
  shippingMethods: "Versandarten",
  shippingProduct: "Versandkosten",
  shippingState: "Versandstatus",
  shop: "Onlineshop",
  shopPlural: "Onlineshops",
  shopify: shopify,
  shopware6: shopware6,
  kaufland: kaufland,
  softMigrationSuccess: "Platzhalter Integration erfolgreich angelegt",
  stateOfTransfer: "Status für Übertragung",
  steps: "Schritt",
  stock: stock,
  stockTitle: "Bestand",
  storageDeliveryConfig: "Lager- und Lieferkonfiguration",
  surchargeProduct: "Zuschläge",
  supplier: "Lieferant",
  taxes: "Steuern",
  taxationMappingTableId: "Besteuerungs-Zuordnung",
  test: test,
  timeBased: "Zeitbasiert",
  timeOfTransfer: "Zeitpunkt der Übertragung",
  timeOfTransferHelp: "Wie und wann wird die Übertragung ausgelöst?",
  timings: "Intervall für neue Aufträge",
  title: {
    journals: "Journale und Konten",
    synchronization: "Synchronisation",
    stock: "Bestand",
    price: "Preise",
    initialImportFile: "Initiale Importdatei",
    initialImportFileSettings: "Initiale Importdatei Einstellungen",
    general: "Allgemein"
  },
  trackingReturns: "Retouren",
  journals: "Verkaufsjournal",
  synchronization: "Synchronisation von Debitoren",
  dataFields: "Datenfelder",
  paymentMapping: "Zahlungsweisen",
  accountMapping: "{appName} Belegart",
  paymentStatus: "{appName} Zahlstatus",
  costCenterMapping: "Kostenstellen",
  vatMapping: "USt.-Zuordnung",
  taxRateMapping: "MwSt.",
  currencyMapping: "Währungen",
  projectMapping: "Projekte",
  titles: {
    accounting: "Buchhaltung",
    additionalSettings: "Weitere Einstellungen",
    debtors: "Debitoren",
    creditors: "Kreditoren",
    articles: "Artikel",
    salesInvoices: "Ausgangsrechnungen",
    creditNotes: "Gutschriften",
    liabilities: "Eingangsrechnungen",
    taxes: "Steuersätze & MWST.",
    projects: "Projekte",
    baseData: "Basisdaten",
    baseSettings: "Grundeinstellungen",
    credentials: "Zugangsdaten",
    dashboard: "Dashboard",
    features: "Features",
    journal: "Artikel",
    prices: "Preise",
    product: "Artikel",
    category: "Kategorie",
    pos: "POS",
    tbOneChannelSelection: "TB.One Kanal",
    productSelection: {
      selection: "Artikelzuordnung",
      configure: "Artikelfilter konfigurieren"
    },
    salesOrder: "Aufträge",
    salesOrder_payment: "Zahlungsarten",
    salesOrder_shipping: "Versandarten",
    settings: {
      title: "Einstellungen",
      wizard: "Grundeinstellungen",
      productAssignment: "Artikelzuordnung",
      advanced: "Erweiterte Einstellungen",
      shop: "Shop",
      externalReferences: "Fremdnummern",
      taxes: "Steuern",
      businessAddress: "Geschäftsadresse"
    },
    system: "Systemfunktionen",
    reporting: "Reporting",
    stock: "Bestand",
    tracking: "Auftragsstatus & Tracking",
    migration: {
      title: "Initialer Datenimport",
      strategy: "Migrationsstrategie",
      settings: "Einstellungen"
    },
    sftpData: "SFTP-Daten",
    offer: "Angebote",
    receipt: "Belege",
    paymentTransactions: "Rückzahlungen",
    venue: "Venue"
  },
  posAssignment: "Kassenzuweisung",
  token: "Token",
  tracking: tracking,
  updateStrategy: "Update Strategie",
  updateStrategyHelp: "Wie und wann wird die Übertragung ausgelöst?",
  url: "URL",
  urlHelp: "URL des anzubindenden Systems",
  useFilter: "Filter anwenden",
  useFilterForAllProducts: "Filter für alle Artikel anwenden",
  useFilterForSelectedProducts: "Filter für ausgewählte Artikel anwenden",
  usedFilters: "Bisher angewandte Filter",
  username: "Benutzername",
  validateCredentials: "Verbindung testen",
  voucherProduct: "Wertgutscheine",
  skipValidation: "Validierung überspringen",
  getTokenByOAuth: "Token über {name} generieren",
  validateSftpData: "SFTP Verbindung testen",
  validateCredentialsError:
    "Bitte überprüfen Sie, ob korrekte Zugangsdaten angegeben wurden",
  validateCredentialsSuccess: "Die Verbindung konnte aufgebaut werden.",
  value: "Wert",
  vatMappingTableId: "MwSt.-Zuordnung",
  warehouse: "Lager",
  wizardError: "Beim Anlegen der Integration gab es einen Fehler.",
  wizardSaving: "Ihre neue Shop-Integration wird erstellt...",
  wizardSuccess:
    "Die Integration {integrationName} wurde erfolgreich angelegt.",
  wizardSalesChannelNotCreated:
    "Die Integration {integrationName} wurde angelegt. Es konnte jedoch kein passender Verkaufskanal angelegt werden. Bitte kontaktiere den Support.",
  woocommerce: woocommerce,
  workflows: "Workflows",
  xentral: "Xentral",
  yes: "Ja",
  invoices: "Rechnungen",
  creditNotes: "Gutschriften",
  uniqueName: "Der Name der Integration darf nur einmal verwendet werden.",
  saveDialog: saveDialog,
  invalidOption:
    "Diese Option ist nicht verfügbar, da sie entweder in deinem Verkaufskanal oder in Xentral entfernt wurde. Bitte entferne diese Option.",
  invalidOptions: "Es sind ungültige Werte in der Konfiguration vorhanden."
};
